module.exports = __webpack_public_path__ + "img/car-alt.e4053605.svg";